module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-en-a1bcba8e6e49a0c910a1aa7b9606b2e7.svg";